import { render, staticRenderFns } from "./mBetRecordHistory.vue?vue&type=template&id=555108bc&scoped=true"
import script from "./mBetRecordHistory.vue?vue&type=script&lang=js"
export * from "./mBetRecordHistory.vue?vue&type=script&lang=js"
import style0 from "./mBetRecordHistory.vue?vue&type=style&index=0&id=555108bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555108bc",
  null
  
)

export default component.exports